import {css} from 'lit';
export const styles = css`:host{appearance:none;border:0;clip:rect(0 0 0 0);display:inline-block;height:0;margin:0;opacity:0;outline:0;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:0}`;
export default styles;
